import { css } from 'lit';

const style = css`
  :host {
    display: block;
  }

  .form-card {
    display: block;
    padding: var(--sl-spacing-x-large, 2rem);
    border: 1px solid var(--sl-color-neutral-300, #d1d5db);
    border-radius: var(--sl-border-radius-large, 0.75rem);
    background: linear-gradient(135deg, var(--sl-color-neutral-0, #ffffff) 0%, var(--sl-color-neutral-50, #f8fafc) 100%);
    box-shadow: var(--sl-shadow-medium, 0 8px 24px rgba(15, 23, 42, 0.08));
  }

  .form-header {
    margin-bottom: var(--sl-spacing-large, 1.25rem);
  }

  .form-header h3 {
    margin: 0 0 0.25rem 0;
    font-size: 1.1rem;
    color: var(--sl-color-neutral-900, #0f172a);
  }

  .form-header p {
    margin: 0;
    color: var(--sl-color-neutral-600, #475569);
    font-size: 0.95rem;
  }

  .form-grid {
    display: grid;
    gap: var(--sl-spacing-large, 1.25rem);
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
  }

  .field-row {
    display: grid;
    grid-template-columns: 1fr;
  }

  .field-row-dual {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--sl-spacing-large, 1.25rem);
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--sl-spacing-small, 0.75rem);
    margin-top: var(--sl-spacing-large, 1.25rem);
  }

  sl-select,
  sl-input,
  sl-textarea {
    width: 100%;
  }

  .act-type-dropdown {
    width: 100%;
    display: block;
  }

  .combobox-panel {
    background: var(--sl-panel-background-color);
    border: 1px solid var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-medium);
    padding: var(--sl-spacing-small);
    box-shadow: var(--sl-shadow-large);
    width: 450px;
  }

  .combobox-menu {
    max-height: 250px;
    overflow-y: auto;
    margin-top: var(--sl-spacing-small);
  }

  /* Customize the scrollbar for the menu */
  .combobox-menu::-webkit-scrollbar {
    width: 8px;
  }
  .combobox-menu::-webkit-scrollbar-track {
    background: var(--sl-color-neutral-50);
    border-radius: var(--sl-border-radius-medium);
  }
  .combobox-menu::-webkit-scrollbar-thumb {
    background: var(--sl-color-neutral-300);
    border-radius: var(--sl-border-radius-medium);
  }
  .combobox-menu::-webkit-scrollbar-thumb:hover {
    background: var(--sl-color-neutral-400);
  }
`;

export default style;
